<template>
  <el-tooltip :content="isEdit?$t('SeaExport.copyAndAddPoItems'):$t('SeaExport.View')">
    <i class="el-icon-document-copy" style="cursor:pointer;font-size:18px" @click="onClick" />
  </el-tooltip>
</template>

<script>
export default {
  name: 'IconDocumentCopy',
  data() {
    return {
      field: '',
      clicked: undefined
    }
  },
  watch: {
    // field(newVal) {
    //   this.init()
    // }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.field = this.params.colDef.field || ''
      const custom = this.params.colDef.custom
      this.isEdit = custom.isEdit || false
      this.clicked = custom.clicked
    },
    onClick() {
      if (typeof this.clicked === 'function') {
        const value = this.params.data[this.field]
        this.clicked({ data: this.params.data, field: this.field, value })
      }
    }
  }
}
</script>

<style>
</style>
